import { render, staticRenderFns } from "./PesquisaUltraprocessados.vue?vue&type=template&id=54dcf964&scoped=true"
import script from "./PesquisaUltraprocessados.vue?vue&type=script&lang=js"
export * from "./PesquisaUltraprocessados.vue?vue&type=script&lang=js"
import style0 from "./PesquisaUltraprocessados.vue?vue&type=style&index=0&id=54dcf964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dcf964",
  null
  
)

export default component.exports